<template>
  <div ref="spinResult" class="spin-inner" v-show="$bus.discountInfo.show">
    <div ref="spinBg" class="spin-bg"></div>
    <div class="spin-discount" ref="spinDis" :style="{transformOrigin: Math.floor($bus.discountDinate.left / 1.2) + 'px'}">
      <p ref="spinTitle" class="spin-title bebas-font">{{$bus.transify['LUCKY_DISCOUNT_GREETINGS']}}</p>
      <div ref="spinContent" class="spin-content bebas-font" :data-text="spinDiscountText">
        <i class="diamond" v-if="getShow"></i>
        <span class="discount" v-html="spinDiscountText"></span>
      </div>
    </div>
    <div ref="discountLight" class="discount-light" :style="{top: $bus.discountDinate.top + 'px', left: $bus.discountDinate.left + 'px'}"></div>
  </div>
</template>

<script>
import VueAnime from '@/utils/animate.js'
const anime = new VueAnime()
export default {
  data () {
    return {
      animeTime: null
    }
  },
  methods: {
    getCurrentDiscount () {
      if (!this.$bus.discountPool || this.$bus.enable === -1) {
        return {}
      }
      return this.$bus.discountPool.find(item => item.pk === this.$bus.enable)
    }
  },
  computed: {
    getShow () {
      const currentDiscount = this.getCurrentDiscount()
      return currentDiscount.discountType === 0
    },
    spinDiscountText () {
      const currentDiscount = this.getCurrentDiscount()
      let offText = this.$bus.transify['LUCKY_OFF']
      if (currentDiscount.discountType === 0) {
        return currentDiscount.discount
      } else {
        return `${currentDiscount.discount}% <span style="font-size: .8em">${offText}</span>`
      }
    }
  },
  watch: {
    '$bus.discountInfo.show': {
      handler (val) {
        if (val) {
          anime.reHeartBeat(this.$refs.spinDis, () => {
            const timeline = anime.timeline()
            timeline.add({
              targets: '.spin-bg',
              opacity: [1, 0],
              duration: 1200,
              easing: 'easeOutCubic'
            }).add({
              targets: '.spin-discount',
              opacity: [1, 0],
              scale: [1, 0],
              duration: 1200,
              easing: 'easeOutCubic'
            }, 0).add({
              targets: '.discount-light',
              opacity: [0, 1, 0],
              rotate: [0, '180deg', '360deg'],
              scale: [0.2, 0.3, 0.3],
              duration: 1600,
              easing: 'linear',
              complete: () => {
                this.$bus.discountInfo.show = false
              }
            }, '-=1200')
          })
        } else {
          this.$refs.spinBg.style.opacity = 1
          this.$refs.spinDis.style.opacity = 1
          this.$refs.spinDis.style.transform = 'none'
          this.$refs.discountLight.style.transform = 'none'
        }
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.spin-inner {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  width: 100vw;
  height: 100vh;
  text-transform: uppercase;
  @include flexcc;
  transform-origin: 72vw center;
}
.spin-bg {
  position: absolute;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, .7);
  // background-size: cover;
}
.spin-discount {
  @include flexcc;
  /* @include px2res(width, 837); */
  width: 90%;
  @include px2res(height, 553);
  position: relative;
  z-index: 2;
  transform-origin: 57vw center;
}
.spin-title {
  display: flex;
  align-items: center;
  @include px2res(padding, 0, 240);
  @include px2res(height, 141);
  color: #fff5c2;
  @include px2res(font-size, 40);
}
.spin-content {
  color: #FBED65;
  @include flexrc;
  @include px2res(font-size, 118);
  width: 100%;
  @include px2res(height, 205);
  .discount {
    @include text-gradient(rgba(251,237,101,1) 0%, rgba(239,181,77,1) 100%);
    filter: drop-shadow(0 4px 0 rgba(242, 68, 0, .6)) drop-shadow(0 -2px 5px rgba(242, 63, 0, .7));
  }
  .diamond {
    @include px2res(width, 96);
    @include px2res(height, 79);
  }
}
.discount-light {
  @include px2res(width, 979);
  @include px2res(height, 700);
  opacity: 0;
  position: absolute;
  // left: 24%;
  // top: 47%;
  z-index: 3;
  transform: scale(.2);
  @include px2res(margin, -380, 0, 0, -490);
}
</style>



// WEBPACK FOOTER //
// src/components/discount/index.vue